import { observer } from 'mobx-react';
import React from 'react';

import TableToolbar from '../../shared/tableToolbar';
import SalesTargetStore from './Store';

import * as api from '../../../stores/api';

@observer
class SaleTargetToolbar extends React.Component {
  handleSearchChange = (_, { value }) => {
    SalesTargetStore.setFieldsValue({ keyword: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    SalesTargetStore.refetch({}, true);
  };

  handleReset = () => {
    SalesTargetStore.resetStore();
  };

  handleCreate = () => {
    return SalesTargetStore.toggleModal(true, { modalType: 'create' })();
  };

  render() {
    const { keyword, loading } = SalesTargetStore;
    return (
      <TableToolbar.Container>
        <TableToolbar.Left onSubmit={this.handleSubmit}>
          <TableToolbar.Input
            placeholder="Search"
            value={keyword}
            onChange={this.handleSearchChange}
            disabled={loading}
          />
          <TableToolbar.SubmitButton disabled={loading}>Search</TableToolbar.SubmitButton>
          <TableToolbar.HighLightButton
            className="negative"
            disabled={loading}
            onClick={this.handleReset}
            style={{ marginLeft: '5px' }}
          >
            Clear
          </TableToolbar.HighLightButton>
        </TableToolbar.Left>
        <TableToolbar.Right>
          {api.isAdmin() && !api.isOnlySearch() && (
            <TableToolbar.HighLightButton className="positive" disabled={loading} onClick={this.handleCreate}>
              Add Sale Target
            </TableToolbar.HighLightButton>
          )}
        </TableToolbar.Right>
      </TableToolbar.Container>
    );
  }
}

export default SaleTargetToolbar;
